import {
  Box,
  Typography,
} from "@mui/material"


function EmptyState({
  title = "Aucune donnée",
  description = "Aucun élément n'est disponible pour le moment.",
  action,
  minHeight = 220,
}) {
  return (
    <Box
      sx={{
        minHeight,
        display: "grid",
        placeItems: "center",
        px: 2,
        py: 4,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          maxWidth: 420,
        }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            mx: "auto",
            mb: 1.2,
            borderRadius: "50%",
            bgcolor: "action.hover",
            border: "1px solid",
            borderColor: "divider",
          }}
        />

        <Typography
          sx={{
            fontWeight: 900,
            fontSize: 16,
          }}
        >
          {title}
        </Typography>

        <Typography
          color="text.secondary"
          sx={{
            mt: 0.5,
            fontSize: 13,
            lineHeight: 1.45,
          }}
        >
          {description}
        </Typography>

        {action ? (
          <Box
            sx={{
              mt: 1.5,
            }}
          >
            {action}
          </Box>
        ) : null}
      </Box>
    </Box>
  )
}


export default EmptyState
